"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    $("[slider-div=true]", this).each(function () {
        var $this = $(this);
        var minRangeValue = parseInt($this.attr("slider-range-min"));
        var maxRangeValue = parseInt($this.attr("slider-range-max"));
        var startLow = parseInt($this.attr("slider-start-low"));
        var startHigh = parseInt($this.attr("slider-start-high"));
        var fromInputSelector = $this.attr("slider-input-selector-from");
        var toIputSelector = $this.attr("slider-input-selector-to");

        $this.slider({
            range: true,
            min: minRangeValue,
            max: maxRangeValue,
            values: [startLow, startHigh],
            slide: function slide(event, ui) {
                var minRangeValue = parseInt($this.attr("slider-range-min"));
                var maxRangeValue = parseInt($this.attr("slider-range-max"));
                var fromInputSelector = $this.attr("slider-input-selector-from");
                var toIputSelector = $this.attr("slider-input-selector-to");
                if (ui.values[0] == $this.slider("option", "min")) {
                    $(fromInputSelector).val("");
                } else {
                    $(fromInputSelector).val(ui.values[0]);
                }
                if (ui.values[1] == $this.slider("option", "max")) {
                    $(toIputSelector).val("");
                } else {
                    $(toIputSelector).val(ui.values[1]);
                }
            }
        });
        if ($(fromInputSelector).val() == $this.slider("option", "min")) {
            $(fromInputSelector).val("");
        } else {
            $(fromInputSelector).val(startLow);
        }
        if ($(toIputSelector).val() == $this.slider("option", "max")) {
            $(toIputSelector).val("");
        } else {
            $(toIputSelector).val(startHigh);
        }
    });

    //Changing slider value when input is modified manually
    $(document).on('change', '[slider-input-from=true]', function () {
        var $this = $(this);
        var sliderSelector = $this.attr('slider-selector');
        var val = $this.val();
        $(sliderSelector).slider('values', 0, val);
    });

    $(document).on('change', '[slider-input-to=true]', function () {
        var $this = $(this);
        var sliderSelector = $this.attr('slider-selector');
        var val = $this.val();
        $(sliderSelector).slider('values', 1, val);
    });
};

var $ = require("jquery");

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/advancedSearchSliders.js
// module id = 1052
// module chunks = 1